import * as smd from "streaming-markdown";

// Log to confirm file is loaded
console.debug("✅ turbo_streams.js loaded successfully");

const markdownParsers = new Map();
const markdownQueues = new Map();

function processMarkdownQueue(targetId, targetElement) {
  const queue = markdownQueues.get(targetId);
  if (!queue || queue.length === 0) return;

  if (!markdownParsers.has(targetId)) {
    markdownParsers.set(
      targetId,
      smd.parser(smd.default_renderer(targetElement)),
    );
  }

  const parser = markdownParsers.get(targetId);

  const chunk = queue.shift(); // Get first chunk from queue

  if (chunk === null) return;

  // Write the chunk to the parser
  smd.parser_write(parser, chunk);

  // If this is the completion signal (empty string), flush the parser
  if (chunk === "") {
    smd.parser_end(parser);
    // Clean up the parser after flushing
    markdownParsers.delete(targetId);
    markdownQueues.delete(targetId);
  }
}

setInterval(() => {
  markdownQueues.forEach((_, targetId) => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      processMarkdownQueue(targetId, targetElement);
    }
  });
}, 10); // every 50ms

Turbo.StreamActions.render_markdown = function () {
  const contentChunk = this.getAttribute("content");
  const targetElement = this.targetElements[0];

  // Guard against missing target element
  if (!targetElement) {
    console.warn("[render_markdown] No target element found");
    return;
  }

  const targetId = targetElement.getAttribute("id");

  if (!markdownQueues.has(targetId)) {
    markdownQueues.set(targetId, []);
  }

  markdownQueues.get(targetId).push(contentChunk);
};

// Add your own Custom Turbo Turbo.StreamActions
// Define Rails helpers in `app/helpers/turbo_stream_actions_helper.rb`
//
// These actions run in the context of a turbo-stream element. You have access to methods like the following:
//
//   this.action - The action attribute value (for example: "append")
//   this.target - The target attribute value (the target element ID)
//   this.targetElements - An array of target elements the template will be rendered to
//   this.templateContent - The contents of the main `<template>`
//
// Source code for the stream element can be found here:
// https://github.com/hotwired/turbo/blob/main/src/elements/stream_element.ts

// Remove elements after X milliseconds
// <%= turbo_stream.remove_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.remove_later = function () {
  setTimeout(() => {
    this.targetElements.forEach((element) => element.remove());
  }, this.getAttribute("after"));
};

// Resets a form
// <%= turbo_stream.reset_form "new_post"
Turbo.StreamActions.reset_form = function () {
  this.targetElements.forEach((element) => element.reset());
};

// Scrolls an element into view
// <%= turbo_stream.scroll_to "comment_1"
Turbo.StreamActions.scroll_to = function () {
  this.targetElements.forEach((element) =>
    element.scrollIntoView({ behavior: "smooth" }),
  );
};

// Add your own Custom Turbo Turbo.StreamActions
// Define Rails helpers in `app/helpers/turbo_stream_actions_helper.rb`
//
// These actions run in the context of a turbo-stream element. You have access to methods like the following:
//
//   this.action - The action attribute value (for example: "append")
//   this.target - The target attribute value (the target element ID)
//   this.targetElements - An array of target elements the template will be rendered to
//   this.templateContent - The contents of the main `<template>`
//
// Source code for the stream element can be found here:
// https://github.com/hotwired/turbo/blob/main/src/elements/stream_element.ts

import { Howl, Howler } from "howler";

// Unlock audio on mobile Safari - must happen on user interaction
// This ensures subsequent sounds can play without user gesture
let audioUnlocked = false;
function unlockAudio() {
  if (audioUnlocked) return;
  audioUnlocked = true;

  // Resume AudioContext if suspended (iOS Safari)
  if (Howler.ctx && Howler.ctx.state === "suspended") {
    Howler.ctx.resume();
  }
}

// Unlock audio on first user interaction
document.addEventListener("touchstart", unlockAudio, { once: true });
document.addEventListener("touchend", unlockAudio, { once: true });
document.addEventListener("click", unlockAudio, { once: true });
document.addEventListener("keydown", unlockAudio, { once: true });

// Print Dymo Label
// <%= turbo_stream.print_dymo_label, printer: "...", label_xml: "...", copies %>

// Show Confirm
// <%= turbo_stream.show_confirm, message: "Are you sure?", header: "Confirm", buttons: { ok: "Yes", cancel: "No" } %>
// Displays a confirmation dialog with the given message and header
// If the user clicks "ok", the action is performed
// If the user clicks "cancel", the action is not performed
Turbo.StreamActions.show_confirmation_modal = function () {
  const message = this.getAttribute("message");
  const header = this.getAttribute("header");
  const buttons = this.getAttribute("buttons");

  console.debug("buttons:");
  console.debug(buttons);

  // if (confirm(message)) {
  //   this.perform()
  // }

  const confirm_dialog = document.createElement("dialog");
  confirm_dialog.setAttribute("class", "confirm_dialog2");
  confirm_dialog.innerHTML = `
      <div class="confirm_dialog_header">${header}!!</div>
      <div class="confirm_dialog_message">${message}!!</div>
      <div class="confirm_dialog_buttons">
        <button class="confirm_dialog_button confirm_dialog_button_cancel">xx${buttons.cancel}</button>
        <button class="confirm_dialog_button confirm_dialog_button_ok">zzz${buttons.confirm}</button>
      </div>
    `;
  document.body.appendChild(confirm_dialog);

  confirm_dialog.showModal();

  confirm_dialog.addEventListener("click", (event) => {
    if (event.target.classList.contains("confirm_dialog_button_cancel")) {
      confirm_dialog.close();
    }

    if (event.target.classList.contains("confirm_dialog_button_ok")) {
      confirm_dialog.close();
      this.perform();
    }
  });
};

// Show Large Text over the entire screen
// with a black background and white text
// <%= turbo_stream.large_text, message: "Hello World" %>
Turbo.StreamActions.large_text = function () {
  const message = this.getAttribute("message");

  const large_text_container = document.createElement("div");
  document.body.appendChild(large_text_container);
  large_text_container.setAttribute(
    "class",
    "large_text_container fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center w-screen h-screen bg-black opacity-0 transition-opacity duration-200 bg-opacity-80 ease-in-out",
  );

  const large_text = document.createElement("div");
  large_text.setAttribute("class", "large_text text-white");
  large_text.innerHTML = message;

  large_text_container.appendChild(large_text);

  // event listener to close the large text, on click of the container
  large_text_container.addEventListener("click", (event) => {
    large_text_container.classList.add("opacity-0");

    setTimeout(() => {
      large_text_container.remove();
    }, 500);
  });

  // Use a timeout to add a delay before starting the fade-in effect
  setTimeout(() => {
    large_text_container.classList.remove("opacity-0");
  }, 100);

  // Use a timeout to add a delay before starting the fade-in effect
  setTimeout(() => {
    large_text_container.classList.add("opacity-0");
  }, 2000);

  setTimeout(() => {
    large_text_container.remove();
  }, 2500);
};

// Speak Text using Speech Synthesis
// <%= turbo_stream.speak, text: "Hello World" %>
Turbo.StreamActions.speak = function () {
  const text = this.getAttribute("text");
  const guid = this.getAttribute("guid");
  console.debug(guid);

  // If the GUID is already in local storage, exit the function
  if (Turbo.StreamActions.checkGUIDinLocalStorage(guid)) {
    return;
  }

  var utterance = new SpeechSynthesisUtterance(text);
  utterance.voice = speechSynthesis.getVoices().filter(function (voice) {
    return voice.name == "Matilda (Premium)";
  })[0];

  window.speechSynthesis.speak(utterance);
};

// Flash Color
// <%= turbo_stream.flash_color, color: "red" %>
// Flashes the background color of the target element
// and then fades back to the original color
Turbo.StreamActions.flash_color = function () {
  const color = this.getAttribute("color");
  const target = document.getElementById(this.target);

  const original_bg_color = target.style.backgroundColor;
  const original_border_color = target.style.borderColor;

  // save orignal background color and border color as data attributes
  // unless they are already set
  if (!target.dataset.originalBackgroundColor) {
    target.dataset.originalBackgroundColor = original_bg_color;
    target.dataset.originalBorderColor = original_border_color;
  }

  // calculate the border color based on the background color
  // the border color is darkened by 20%
  // if the color is a hex value, we can use the hex value to calculate the border color

  // if the color is a hex value
  if (color.match(/^#([0-9a-f]{3}){1,2}$/i)) {
    // remove the hash
    const hex = color.substring(1);

    // convert 3 digit hex to 6 digit hex
    const hex6 = hex.length == 3 ? hex.replace(/(.)/g, "$1$1") : hex;

    // convert hex to rgb
    const rgb = parseInt(hex6, 16);

    // extract the red, green, and blue values
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;

    // darken the color by 20%
    const darkened_r = Math.round(r * 0.8);
    const darkened_g = Math.round(g * 0.8);
    const darkened_b = Math.round(b * 0.8);

    // convert the darkened color back to hex
    const darkened_hex = (
      (darkened_r << 16) +
      (darkened_g << 8) +
      darkened_b
    ).toString(16);

    // set the border color
    target.style.borderColor = "#" + darkened_hex;
  }

  target.style.backgroundColor = color;

  setTimeout(() => {
    target.style.backgroundColor = "#fff";
    target.style.borderColor = "rgb(229 231 235)";
  }, 1000);
};

// Modal with Dynamic Button To With Resource
// <%= turbo_stream.modal_with_dynamic_button_to_with_resource, resource: @order, method_name: "unhold!", title: "Unhold Order", message: "Are you sure you want to unhold this order?" %>
Turbo.StreamActions.modal_with_dynamic_button_to_with_resource = function () {
  // check that the window is focused
  if (!document.hasFocus()) {
    return;
  }

  const resource_id = JSON.parse(this.getAttribute("resource_id"));
  const class_name = this.getAttribute("class_name");
  const method_name = this.getAttribute("method_name");
  const title = this.getAttribute("title");
  const button_title = this.getAttribute("button_title");
  const message = this.getAttribute("message");

  const modal = document.createElement("dialog");
  modal.setAttribute("class", "bg-white rounded-xl shadow w-1/2 p-0");
  modal.style.minHeight = "12rem!important";
  modal.innerHTML = `
  <div class="w-full flex justify-between items-center p-4 border-b">
    <div class="text-gray-900 font-medium">${title}</div>
    <div><button type="button" onclick="this.closest('dialog').close()" class="w-8 h-8 hover:bg-gray-50 rounded-full text-sm text-gray-700 hover:text-gray-900"><i class="fal fa-times text-2xl"></i></button></div>
  </div>
  <div class="modal-body p-4">
    <p>${message}</p>
  </div>
  <div class="p-4 flex justify-between items-center border-t">
    <div>
    <button class="chick-secondary-button" onclick="this.closest('dialog').close()">Cancel</button>
    </div>
    <div>
    <form class="button_to" method="post" action="/admin/call_dynamic_instance_method?class_name=${class_name}&amp;method_name=${method_name}&amp;resource_id=${resource_id}">
    <button class="chick-primary-button" type="submit" onclick="this.closest('dialog').close()">${button_title}</button>
    <input type="hidden" name="authenticity_token" value="${document.querySelector('meta[name="csrf-token"]').content}" autocomplete="off">
    </form>
  </div>
  </div>
`;

  document.body.appendChild(modal);

  modal.showModal();

  modal.querySelector(".modal-close").addEventListener("click", () => {
    modal.close();
  });

  modal.querySelector(".modal-cancel").addEventListener("click", () => {
    modal.close();
  });

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.close();
    }
  });
};

// Show Progress Bar
// <%= turbo_stream.show_progress_bar %>
Turbo.StreamActions.show_progress_bar = function () {
  const title = this.getAttribute("title");

  const progress_bar = document.getElementById("progress-bar");

  if (title) {
    progress_bar.querySelector("#progress-bar-title").innerHTML = title;
  }

  progress_bar.classList.remove("hidden");
  setTimeout(() => {
    progress_bar.classList.remove("translate-y-full");

    setTimeout(() => {
      progress_bar.classList.remove("duration-300");
    }, 300);
  }, 50);
};

// Set the progress bar to a specific value
// <%= turbo_stream.set_progress_bar, progress: "50", status:"1 of 23" %>
Turbo.StreamActions.set_progress_bar = function () {
  const progress = this.getAttribute("progress");
  const status = this.getAttribute("status");

  const progress_bar = document.getElementById("progress-bar");

  progress_bar.querySelector("#progress-bar-status").innerHTML = status;
  progress_bar.querySelector("#progress-bar-progress").style.width =
    progress + "%";
};

// Hide Progress Bar
// <%= turbo_stream.hide_progress_bar %>
Turbo.StreamActions.hide_progress_bar = function () {
  const progress_bar = document.getElementById("progress-bar");
  progress_bar.querySelector("#progress-bar-progress").style.width = 100 + "%";

  setTimeout(() => {
    progress_bar.classList.add("duration-300");
    progress_bar.classList.add("translate-y-full");

    setTimeout(() => {
      progress_bar.classList.add("hidden");
      progress_bar.classList.remove("duration-300");
      progress_bar.querySelector("#progress-bar-status").innerHTML = "";
      progress_bar.querySelector("#progress-bar-progress").style.width = "0%";
      progress_bar.querySelector("#progress-bar-title").innerHTML = "";
    }, 900);
  }, 500);

  // Reset the progress bar
};

// Remove elements after X milliseconds
// <%= turbo_stream.remove_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.remove_later = function () {
  setTimeout(() => {
    this.targetElements.forEach((element) => element.remove());
  }, this.getAttribute("after"));
};

// Move element to bottom of its parent container
// <%= turbo_stream.move_to_bottom(target: "my-id") %>
Turbo.StreamActions.move_to_bottom = function () {
  this.targetElements.forEach((element) => {
    const parent = element.parentElement;
    if (parent) {
      // Remove the element from its current position
      element.remove();
      // Append it to the end of the parent (bottom of list)
      parent.appendChild(element);
    }
  });
};

// Move element to top of its parent container
// <%= turbo_stream.move_to_top(target: "my-id") %>
Turbo.StreamActions.move_to_top = function () {
  this.targetElements.forEach((element) => {
    const parent = element.parentElement;
    if (parent) {
      // Remove the element from its current position
      element.remove();
      // Insert it at the beginning of the parent (top of list)
      parent.insertBefore(element, parent.firstChild);
    }
  });
};

// Show Confetti
// <%= turbo_stream.confetti(target: "my-id") %>
Turbo.StreamActions.confetti = function () {
  const target = this.getAttribute("target");

  this.targetElements.forEach((element) => {
    party.confetti(element, {
      count: party.variation.range(20, 40),
      color: party.Color.fromHex("#4F46E5"),
    });
  });
};

// Hide elements afer X milliseconds
// <%= turbo_stream.hide_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.hide_later = function () {
  setTimeout(() => {
    this.targetElements.forEach((element) => (element.style.display = "none"));
  }, this.getAttribute("after"));
};

// Show elements after X milliseconds
// <%= turbo_stream.show_later, target: "my-id", after: "2000" %>
Turbo.StreamActions.show_later = function () {
  setTimeout(() => {
    this.targetElements.forEach((element) => (element.style.display = ""));
  }, this.getAttribute("after"));
};

// Toggle element visibillity
// <%= turbo_stream.toggle, target: "my-id" %>
Turbo.StreamActions.toggle = function () {
  this.targetElements.forEach((element) => {
    if (element.style.display === "none") {
      element.style.display = "";
    } else {
      element.style.display = "none";
    }
  });
};

// Add a skeleton to element (make it pulse with a loading animation)
// <%= turbo_stream.add_skeleton, target: "my-id" %>
Turbo.StreamActions.add_skeleton = function () {
  // get all elements with the class 'skeletonable'
  const elements = document.querySelectorAll(".skeletonable");

  // loop through each element
  elements.forEach((element) => {
    // If the element is a button, disable it, and hide the text
    if (element.tagName == "BUTTON") {
      element.disabled = true;

      // Get all the children of the button
      const children = element.childNodes;

      // Loop through each child
      children.forEach((child) => {
        // If the child is a span, hide it
        if (child.tagName == "SPAN") {
          child.style.display = "none";
        }
      });
    }

    element.classList.add("skeleton-pulse");
  });
};

// Remove skeleton from element
// <%= turbo_stream.remove_skeleton, target: "my-id" %>
Turbo.StreamActions.remove_skeleton = function () {
  // get all elements with the class 'skeletonable'
  const elements = document.querySelectorAll(".skeletonable");

  // loop through each element
  elements.forEach((element) => {
    if (element.tagName == "BUTTON") {
      element.disabled = false;

      // Get all the children of the button
      const children = element.childNodes;

      // Loop through each child
      children.forEach((child) => {
        // If the child is a span, show it
        if (child.tagName == "SPAN") {
          child.style.display = "";
        }
      });
    }

    element.classList.remove("skeleton-pulse");
  });
};

// Change the classes on multiple elements
// <%= turbo_stream.multi_change_classes(changes) %>
// changes will be an array of objects, with a target and classes_to_add, and classes_to_remove_keys
Turbo.StreamActions.multi_change_classes = function () {
  const changes = JSON.parse(this.getAttribute("changes"));

  changes.forEach((change) => {
    const target = change.target;
    const classes_to_add = change.classes_to_add;
    const classes_to_remove = change.classes_to_remove;

    const element = document.getElementById(target);

    if (classes_to_add) {
      classes_to_add.forEach((class_name) => {
        if (class_name) {
          element.classList.add(class_name);
        }
      });
    }

    if (classes_to_remove) {
      classes_to_remove.forEach((class_name) => {
        if (class_name) {
          element.classList.remove(class_name);
        }
      });
    }
  });
};

// Add class to elemnt
// <%= turbo_stream.add_class(target: "my-id", class_name: "my-class") %>
Turbo.StreamActions.add_class = function () {
  this.targetElements.forEach((element) =>
    element.classList.add(this.getAttribute("class_name")),
  );
};

// Add classes to element
// <%= turbo_stream.add_classes(target: "my-id", class_names: "my-class1 my-class2") %>
Turbo.StreamActions.add_classes = function () {
  this.targetElements.forEach((element) => {
    const classes = this.getAttribute("class_names").split(" ");
    classes.forEach((class_name) => element.classList.add(class_name));
  });
};

// Remove class from element
// <%= turbo_stream.remove_class(target: "my-id", class_name: "my-class") %>
Turbo.StreamActions.remove_class = function () {
  this.targetElements.forEach((element) =>
    element.classList.remove(this.getAttribute("class_name")),
  );
};

// Remove classes from element
// <%= turbo_stream.remove_classes(target: "my-id", class_names: "my-class1 my-class2") %>
Turbo.StreamActions.remove_classes = function () {
  this.targetElements.forEach((element) => {
    const classes = this.getAttribute("class_names").split(" ");
    classes.forEach((class_name) => element.classList.remove(class_name));
  });
};

// Mutate classes on element
// <%= turbo_stream.change_classes(target: "my-id", classes_to_add: "my-class1 my-class2", classes_to_remove: "my-class1 my-class2") %>
Turbo.StreamActions.change_classes = function () {
  this.targetElements.forEach((element) => {
    const classes_to_add = this.getAttribute("classes_to_add").split(" ");
    const classes_to_remove = this.getAttribute("classes_to_remove").split(" ");

    classes_to_add.forEach((class_name) => element.classList.add(class_name));
    classes_to_remove.forEach((class_name) =>
      element.classList.remove(class_name),
    );
  });
};

// Emit Event
// <%= turbo_stream.emit_event(event_name, target, detail: nil) %>
Turbo.StreamActions.emit_event = function () {
  const eventName = this.getAttribute("event_name");
  const detailStr = this.getAttribute("detail");

  console.debug("[Turbo.StreamActions.emit_event] Event:", eventName);
  console.debug("[Turbo.StreamActions.emit_event] Detail:", detailStr);

  // get convert the JSON string to an object
  const detail = JSON.parse(detailStr);

  const event = new CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    detail: detail,
  });

  console.debug(
    "[Turbo.StreamActions.emit_event] Dispatching event to window:",
    event,
  );
  window.dispatchEvent(event);
};

Turbo.StreamActions.append_html = function () {
  this.targetElements.forEach((element) =>
    element.insertAdjacentHTML("beforeend", this.getAttribute("html_content")),
  );
};

// Alert
// <%= alert(message) %>
Turbo.StreamActions.alert = function () {
  alert(this.getAttribute("message"));
};

// Download file
// <%= turbo_stream.download_file("https://example.com/file.pdf") %>
Turbo.StreamActions.download_file = function () {
  const guid = this.getAttribute("guid");

  // If the GUID is already in local storage, exit the function
  if (Turbo.StreamActions.checkGUIDinLocalStorage(guid)) {
    return;
  }

  // Check if current tab has focus
  if (document.hasFocus()) {
    // Open the file in a new tab
    window.open(this.getAttribute("url"), "_blank");
  } else {
  }
};

// Download Base64 file
// <%= turbo_stream.download_base64_file("data:application/pdf;base64", "file.pdf") %>
Turbo.StreamActions.download_base64 = function () {
  const guid = this.getAttribute("guid");

  // If the GUID is already in local storage, exit the function
  if (Turbo.StreamActions.checkGUIDinLocalStorage(guid)) {
    return;
  }

  // if (document.hasFocus()) {

  // check if scope_to_tab_id is not null
  if (this.getAttribute("scope_to_tab_id")) {
    // check if scope_to_tab_id == current tab id
    console.debug("scope_to_tab_id: " + this.getAttribute("scope_to_tab_id"));
    console.debug("window._tabId: " + window._tabId);
    if (window._tabId != this.getAttribute("scope_to_tab_id")) {
      return;
    }
  }

  let base64Data = this.getAttribute("base64_data");
  const fileName = this.getAttribute("filename");

  // Step 1: Convert the base64 string to a binary string
  const binaryString = window.atob(base64Data);

  // Step 2: Convert the binary string to a Blob
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: "application/pdf" });

  // Step 3: Create a download link element with the Blob URL
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;

  // Step 4: Trigger the download by clicking the link programmatically
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // } else {

  // }
};

// Scroll to element
// <%= turbo_stream.scroll_to(target: "my-id") %>
Turbo.StreamActions.scroll_to = function () {
  this.targetElements.forEach((element) => element.scrollIntoView());
};

// Go to URL
Turbo.StreamActions.go_to = function () {
  window.location = this.getAttribute("url");
};

Turbo.StreamActions.set_inner_text = function () {
  this.targetElements.forEach(
    (element) => (element.innerText = this.getAttribute("text")),
  );
};

Turbo.StreamActions.type_inner_text = function () {
  this.targetElements.forEach((element) => {
    const text = this.getAttribute("text");
    const speed = this.getAttribute("speed") || 40;
    element.textContent = "";
    let i = 0;
    function typing() {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(typing, speed);
      }
    }
    typing();
  });
};

Turbo.StreamActions.set_inner_html = function () {
  // console.debug(this.getAttribute("html"));
  this.targetElements.forEach(
    (element) => (element.innerHTML = this.getAttribute("html")),
  );
};

Turbo.StreamActions.enable_button = function () {
  this.targetElements.forEach((element) => (element.disabled = false));
};

Turbo.StreamActions.disable_button = function () {
  this.targetElements.forEach((element) => (element.disabled = true));
};

Turbo.StreamActions.disable_element = function () {
  this.targetElements.forEach((element) => (element.disabled = true));
};

Turbo.StreamActions.enable_element = function () {
  this.targetElements.forEach((element) => (element.disabled = false));
};

Turbo.StreamActions.remove_element = function () {
  this.targetElements.forEach((element) => element.remove());
};

Turbo.StreamActions.set_value = function () {
  this.targetElements.forEach(
    (element) => (element.value = this.getAttribute("value")),
  );
};

Turbo.StreamActions.set_attribute = function () {
  this.targetElements.forEach((element) =>
    element.setAttribute(this.getAttribute("name"), this.getAttribute("value")),
  );
};

Turbo.StreamActions.remove_attribute = function () {
  this.targetElements.forEach((element) =>
    element.removeAttribute(this.getAttribute("name")),
  );
};

Turbo.StreamActions.set_style = function () {
  this.targetElements.forEach(
    (element) =>
      (element.style[this.getAttribute("style")] = this.getAttribute("value")),
  );
};

Turbo.StreamActions.remove_style = function () {
  this.targetElements.forEach(
    (element) => (element.style[this.getAttribute("name")] = ""),
  );
};

Turbo.StreamActions.set_property = function () {
  this.targetElements.forEach(
    (element) =>
      (element[this.getAttribute("property")] = this.getAttribute("value")),
  );
};

Turbo.StreamActions.remove_property = function () {
  this.targetElements.forEach(
    (element) => (element[this.getAttribute("name")] = ""),
  );
};

Turbo.StreamActions.set_checked = function () {
  this.targetElements.forEach(
    (element) => (element.checked = this.getAttribute("checked")),
  );
};

// Get the next thread ID in the list after the specified thread ID
function getNextThreadId(currentThreadId) {
  // Find all thread elements in the list
  const threadElements = document.querySelectorAll(
    '[id^="item_email_thread_"]',
  );

  // Find the current thread element
  const currentThreadElement = document.querySelector(
    `#item_email_thread_${currentThreadId}`,
  );
  if (!currentThreadElement) return null;

  // Get the next sibling thread element
  const nextThreadElement = currentThreadElement.nextElementSibling;
  if (!nextThreadElement || !nextThreadElement.id) return null;

  // Extract thread ID from the next element's ID (format: item_email_thread_123)
  const match = nextThreadElement.id.match(/item_email_thread_(\d+)/);
  return match ? match[1] : null;
}

// Make function globally accessible
window.getNextThreadId = getNextThreadId;

// Add current thread ID to archive forms
document.addEventListener("turbo:load", function () {
  // Intercept all archive button clicks to add current thread info (use capture phase)
  document.addEventListener(
    "click",
    function (event) {
      // Check if this is an archive button - handle both types:
      // 1. Dynamic button (call_dynamic_instance_method)
      // 2. Direct thread archive (/threads/X/archive)
      const dynamicButton = event.target.closest(
        'button[data-dynamic-button-method-name-value="archive!"]',
      );
      const directButton = event.target.closest(
        'button[data-tool-registry-tool-name-value="archive_thread"]',
      );

      const button = dynamicButton || directButton;
      if (!button) return;

      // Prevent the default behavior and stop all propagation
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // Get the form
      const form = button.closest("form");
      if (!form) return;

      // Get current thread ID from the email_thread_X_actions div in the DOM
      const actionsDiv = document.querySelector(
        '[id^="email_thread_"][id$="_actions"]',
      );
      if (!actionsDiv) return;

      const actionsDivMatch = actionsDiv.id.match(/email_thread_(\d+)_actions/);
      if (!actionsDivMatch) return;

      const currentThreadId = actionsDivMatch[1];

      // Get archived thread ID - different methods for different button types
      let archivedThreadId;
      if (dynamicButton) {
        // Dynamic button stores it in data attribute
        archivedThreadId = dynamicButton.getAttribute(
          "data-dynamic-button-resource-id-value",
        );
      } else if (directButton) {
        // Direct button stores it in the form action URL (/threads/76/archive)
        const actionMatch = form.action.match(/\/threads\/(\d+)\/archive/);
        archivedThreadId = actionMatch ? actionMatch[1] : null;
      }

      if (!archivedThreadId) return;

      // Get the next thread ID
      const nextThreadId = getNextThreadId(archivedThreadId);

      // Add current thread and next thread parameters to form action
      const actionUrl = new URL(form.action, window.location.origin);
      actionUrl.searchParams.set("current_thread_id", currentThreadId);
      if (nextThreadId) {
        actionUrl.searchParams.set("next_thread_id", nextThreadId);
      }
      form.action = actionUrl.toString();

      // Now submit the form via Turbo using requestSubmit() which preserves Turbo behavior
      if (form.requestSubmit) {
        form.requestSubmit(button);
      } else {
        // Fallback for older browsers
        form.submit();
      }
    },
    true,
  ); // Use capture phase to intercept before other handlers
});

Turbo.StreamActions.set_selected = function () {
  console.debug(this);
  // set the option with the value to selected
  this.targetElements.forEach((element) => {
    element.value = this.getAttribute("value");
  });
};

Turbo.StreamActions.set_focus = function () {
  this.targetElements.forEach((element) => element.focus());
};

Turbo.StreamActions.set_blur = function () {
  this.targetElements.forEach((element) => element.blur());
};

Turbo.StreamActions.set_data = function () {
  this.targetElements.forEach(
    (element) =>
      (element.dataset[this.getAttribute("name")] = this.getAttribute("value")),
  );
};

Turbo.StreamActions.remove_data = function () {
  this.targetElements.forEach(
    (element) => delete element.dataset[this.getAttribute("name")],
  );
};

Turbo.StreamActions.set_title = function () {
  document.title = this.getAttribute("title");
};

Turbo.StreamActions.set_meta = function () {
  const meta = document.querySelector(
    `meta[name="${this.getAttribute("name")}"]`,
  );
  if (meta) {
    meta.content = this.getAttribute("content");
  }
};

Turbo.StreamActions.remove_meta = function () {
  const meta = document.querySelector(
    `meta[name="${this.getAttribute("name")}"]`,
  );
  if (meta) {
    meta.remove();
  }
};

Turbo.StreamActions.remove_data_attribute = function () {
  this.targetElements.forEach(
    (element) => delete element.dataset[this.getAttribute("name")],
  );
};

Turbo.StreamActions.remove_meta_tag = function () {
  const meta = document.querySelector(
    `meta[name="${this.getAttribute("name")}"]`,
  );
  if (meta) {
    meta.remove();
  }
};

Turbo.StreamActions.clear_storage = function () {
  localStorage.clear();
};

Turbo.StreamActions.set_storag_item = function () {
  localStorage.setItem(this.getAttribute("key"), this.getAttribute("value"));
};

Turbo.StreamActions.remove_storage_item = function () {
  localStorage.removeItem(this.getAttribute("key"));
};

Turbo.StreamActions.console_log = function () {
  console.log(this.getAttribute("message"));
};

Turbo.StreamActions.play_sound = function () {
  const guid = this.getAttribute("guid");
  console.debug(guid);
  // If the GUID is already in local storage, exit the function
  if (Turbo.StreamActions.checkGUIDinLocalStorage(guid)) {
    return;
  }

  // Resume AudioContext if suspended (iOS Safari)
  if (Howler.ctx && Howler.ctx.state === "suspended") {
    Howler.ctx.resume();
  }

  // use Howler to play sound
  let sound = new Howl({
    src: [this.getAttribute("url")],
  });
  sound.play();
};

Turbo.StreamActions.animate = function () {
  // get duration and convert it to integer
  const fadeDuration = parseInt(this.getAttribute("duration"));

  // get the source element
  const sourceElement = document.getElementById(
    this.getAttribute("source_element_id"),
  );

  // get the target element
  const targetElement = document.getElementById(
    this.getAttribute("target_element_id"),
  );

  // Get the source and target positions
  const sourceRect = sourceElement.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();

  // Create a clone of the source element
  const clone = sourceElement.cloneNode(true);

  // Set the cloned div's styles
  clone.style.position = "fixed";
  clone.style.top = `${sourceRect.top}px`;
  clone.style.left = `${sourceRect.left}px`;
  clone.style.width = `${sourceRect.width}px`;
  clone.style.height = `${sourceRect.height}px`;
  clone.style.zIndex = 1000;

  // Append to the body
  document.body.appendChild(clone);

  // Create the animation
  const animation = clone.animate(
    [
      {
        // from
        top: `${sourceRect.top}px`,
        left: `${sourceRect.left}px`,
        opacity: 1,
      },
      {
        // to
        top: `${targetRect.top}px`,
        left: `${targetRect.left + 20}px`,
        opacity: 0,
      },
    ],
    {
      duration: fadeDuration, // Animation duration
      easing: "ease-in-out", // Any easing function
    },
  );

  // Remove the clone when the animation is finished
  animation.onfinish = () => {
    document.body.removeChild(clone);
  };
};

Turbo.StreamActions.hide = function () {
  this.targetElements.forEach((element) => (element.style.display = "none"));
};

Turbo.StreamActions.show = function () {
  this.targetElements.forEach((element) => (element.style.display = ""));
};

Turbo.StreamActions.reload_turboframe = function () {
  console.debug("🔄 Reload Turbo Frame");
  const turbo_frame = document.getElementById(this.getAttribute("target"));
  turbo_frame.reload();
};

Turbo.StreamActions.fetch_weight = function () {
  console.debug("⚖️ Report weight");
  window.reportWeight();
};

Turbo.StreamActions.get_scales_status = function () {
  console.debug("⚖️ Report Scales Status");
  window.reportScalesConnected();
};

Turbo.StreamActions.resize_textarea = function () {
  let textarea = document.getElementById(this.getAttribute("target"));
  textarea.style.height = textarea.scrollHeight + "px";
};

Turbo.StreamActions.checkGUIDinLocalStorage = function (guid) {
  // check if the guid is in local storage
  if (localStorage.getItem(guid)) {
    console.debug(guid);
    // if it is, then skip the download
    return true;
  } else {
    // if it is not, then add it to local storage
    // with the current timestamp
    localStorage.setItem(guid, Date.now());
    return false;
  }
};
